import { TMobileRouterPath } from "../hooks/router";
import { routes } from "../router/mobile/routes";

type IScreenTimeEvent = Partial<{
  [prop in Partial<TMobileRouterPath>]: string;
}>;

export const screenTimeEvent: IScreenTimeEvent = {
  [routes.healthOverview.path]: "Health Overview",
  [routes.healthCare.path]: "Care",
  [routes.healthReminders.path]: "Reminders",
  [routes.addReminder.path]: "Add Reminder",
  [routes.healthChat.path]: "AI Chat",
  [routes.patientProfile.path]: "Profile",
  [routes.aiCoach.path]: "AI Coach",
  [routes.settings.path]: "Settings",
  [routes.userInfo.path]: "User Info",
  [routes.changePassword.path]: "Change Password",
  [routes.changePin.path]: "Change PIN",
  [routes.notificationSettings.path]: "Notification Settings",
  [routes.contactSupport.path]: "Contact Support",
  [routes.faq.path]: "FAQ",
  [routes.feedback.path]: "Feedback",
};
